import React, { useEffect, useState } from 'react'
import { Create, required, SimpleForm, TextInput, useNotify, useRedirect, useTranslate } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { ColorPIckerInput } from 'src/components/uiElements/fields/ColorPIckerInput'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'

export const TagCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [workUnitList, setWorkUnitList] = useState([])
  const [loadingWorkUnitList, setLoadingWorkUnitList] = useState(false)

  const getWorkUnit = async (long_name, minLength = 3) => {
    if (long_name?.length < minLength) {
      setWorkUnitList([])
      return
    }

    try {
      setLoadingWorkUnitList(true)
      const allWorkUnit = await workUnitServices.getByAll({ long_name: long_name })
      setWorkUnitList(allWorkUnit)
      setLoadingWorkUnitList(false)
    } catch (error) {
      setWorkUnitList([])
      setLoadingWorkUnitList(false)
    }
  }

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.tag') },
    })
    redirect('/tag')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.tag') },
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_tag')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.short_name')}>
              <TextInput source='short_name' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap
              label={translate('ra.field.work_unit')}
              required
              tooltiptext={translate('ra.message.valid_characters', { num: 3 })}
            >
              <AutocompleteInput
                source='work_unit_id'
                options={workUnitList}
                loading={loadingWorkUnitList}
                optionValue='id'
                optionsText={['long_name']}
                onSearch={getWorkUnit}
                validate={[required()]}
                useOptionValue={true}
                positionOptionsText={0}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.symbol')}>
              <TextInput source='symbol' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.color')}>
              <ColorPIckerInput source='color' fullWidth validate={[required()]} />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
